export class SettingModel {
    public SettingId: number;
    public ConfigSettingId: number;
    public Name: string;
    public Value: string;
    public tempValue: any;

    public AccountId: number;
    public ModuleId: number;
    public InputType: string;
    public SiteId: number;
    public extension: string;
}



// WEBPACK FOOTER //
// ./src/app/models/settingModel.ts